var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageSelectWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#ffffff",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "languageIconTitle"
  }, "Language") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "languageIconTitle"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12,22 C14.6666667,19.5757576 16,16.2424242 16,12 C16,7.75757576 14.6666667,4.42424242 12,2 C9.33333333,4.42424242 8,7.75757576 8,12 C8,16.2424242 9.33333333,19.5757576 12,22 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M2.5 9L21.5 9M2.5 15L21.5 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageSelectWhite);
export default __webpack_public_path__ + "static/media/LanguageSelectWhite.704a138a6219e30b67a820432eee2d75.svg";
export { ForwardRef as ReactComponent };